const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/components/security/styles.js